import { i18n } from "i18next";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { DesignSystemProvider, ErrorTile } from "chameleon/lib/components";

import { usePubSub } from "checkout-query-client/hooks/use-pub-sub";
import {
  PubSubMessage,
  PubSubNamespace,
} from "checkout-query-client/publish-subcriber/types";
import { Errors } from "checkout-query-client/types/error";

import { sendCustomAction } from "datadog-loader/loader";

export const CriticalError = ({
  error,
  i18n,
}: {
  error?: Error | null;
  i18n?: i18n;
}) => {
  const { t } = useTranslation("combined", { i18n });
  const { publish } = usePubSub();
  const title = t("errorHandler.title");
  const [caption, setCaption] = useState<string>(t("errorHandler.caption"));

  useEffect(() => {
    if (error?.message.includes(Errors.EncryptionNotAvailable)) {
      setCaption(t("errorHandler.securityCaption"));
      sendCustomAction({ name: "EncryptionNotSupported", context: { error } });
      publish({
        level: "error",
        namespace: PubSubNamespace.unknown,
        message: PubSubMessage.SecurityRequirementsNotMet,
      });
    } else if (error?.message.includes(Errors.APIRequestFailed)) {
      // DD emitted as part of client
      sendCustomAction({
        name: "CriticalErrorFetchingAPI",
        context: { error },
      });
      publish({
        level: "error",
        namespace: PubSubNamespace.unknown,
        message: PubSubMessage.RequiredAPIsNotAvailable,
      });
    } else {
      sendCustomAction({ name: "UnknownError", context: { error } });
      publish({
        level: "error",
        namespace: PubSubNamespace.unknown,
        message: PubSubMessage.UnknownError,
      });
    }
  }, [error]);

  return (
    <div data-testid="critical-error">
      <DesignSystemProvider>
        <ErrorTile title={title} caption={caption} />
      </DesignSystemProvider>
    </div>
  );
};
